import priceInfo from '../misc/priceInfo.jsx';
import doctorInfo from '../misc/doctorInfo.jsx';

export const english = {
    translation: {
      header: {
        name: 'Han TCM',
        option1: 'About Us',
        option2: 'Services',
        option3: 'Contact Us',
        bookOnline: 'Book Online',
        languageSwitch: '切换中文',
        brandName: 'Han TCM'
      },
      floatingContact:{
        bookOnline: 'Book Online',
        wechatLabel: 'Or scan QR code to add Wechat',
        callLabel: 'Or call: ',
        phone: '604-928-1898'
      },
      booking:{
        title: 'Book Online',
        hoursTitle: 'Clinic Hours:',
        hours1: 'Mon – Sat: 10:00am – 8:00pm',
        hours2: 'Sun: 10:00am – 6:00pm'
      },
      clinicInfo:[
        {
          id: 0,
          title: 'Our Philosophy',
          description: 'Canadian Han TCM Clinic is a TCM clinic that mainly provides outpatient services and treatments of traditional Chinese medicine. Guided by the theories of TCM, we offer diagnostic and treatment services using traditional Chinese medical techniques such as Chinese herbal medicine (traditional herbs and herbal granules), acupuncture, Tuina massage, cupping, and scraping. We provide comprehensive TCM treatment plans based on your individual health condition and needs.',
        },
        {
          id: 1,
          title: 'Tuina Massage',
          description: 'Tuina massage is a traditional Chinese medical therapy that involves using various hand techniques, such as pushing, pulling, pressing, kneading, rubbing, pinching, and tapping, on the painful, fatigued, or uncomfortable areas of the patient\'s body based on TCM meridian and acupoint theory. It aims to achieve the therapeutic effects of dredging meridians, promoting the flow of Qi and blood, healing injuries, relieving pain, dispelling evil, and harmonizing Yin and Yang.',
        },
        {
          id: 2,
          title: 'Acupuncture',
          description: 'Acupuncture is a method of treating diseases in TCM that originated in China. It involves using needles and moxibustion under the guidance of TCM theory. "needling" refers to the use of needles to treat diseases by puncturing specific acupoints on the body. Based on the TCM principle of "tonifying deficiencies and reducing excesses," needling techniques such as tonifying, reducing, combination of tonifying and reducing are used to achieve the body\'s own regulatory response. "Moxibustion" refers to the use of moxa sticks or cones to warm and stimulate the acupoints, which penetrates the skin and warms the Qi and blood. Acupuncture stimulates the body\'s acupoints in this way and adjusts the functions of Qi and blood, organs, and viscera through the conduction of the meridians in the whole body, achieving the goal of "reinforcing the healthy and dispelling the pathogenic," "treating diseases and maintaining health."',
        },
        {
          id: 3,
          title: 'Chinese Herbal Medicine',
          description: 'Chinese herbal medicine is a type of natural medicine that is collected, processed, formulated, and clinically applied based on TCM theory. It refers to substances used to prevent, diagnose, and treat diseases, as well as for rehabilitation and health preservation under the guidance of TCM theory. Chinese herbal medicine mainly comes from natural herbs and their processed products, including plant medicine, animal medicine, mineral medicine, and some chemical and biological drugs. Natural plant medicine accounts for the majority of Chinese herbal medicine, which is why it is commonly called "materia medica." ',
        },
        {
          id: 4,
          title: 'Cupping',
          description: 'Cupping therapy is a traditional Chinese medicine method that uses cups as a tool and negative pressure created by methods such as burning and suction to cause local congestion on the body surface. It is believed to stimulate circulation, regulate Qi and blood flow, reduce swelling and pain, and expel cold and wind. Cupping therapy has a long history in ancient China, as early as the Western Han Dynasty (202 BC) in the book "Fifty-two Prescriptions" there is a record of "horn method" (equivalent to fire cupping).',
        },
        {
          id: 5,
          title: 'Gua Sha',
          description: 'Gua Sha is a traditional Chinese medicine method that is based on the theory of meridians and acupoints. Using special scraping tools and corresponding techniques, a certain medium is applied to the body surface for repeated scraping and friction to cause local redness, petechiae or ecchymosis, which helps to promote blood circulation, relieve pain, and relax muscle and tendons. It can be used in combination with acupuncture, cupping, and bloodletting to enhance the effects of promoting blood circulation, removing blood stasis, regulating channels and collaterals, expelling evil and detoxification.',
        },
        {
          id: 6,
          title: 'Head Therapy',
          description: 'Head therapy is a method of moderate massage, pressing, rubbing, and combing the head and neck according to the distribution of meridians in the head and neck. It is a very comfortable way of health preservation that can quickly relieve dizziness, headache, neck stiffness and soreness. Head therapy can also help with sleep, relieve fatigue, and regulate white hair and hair loss.',
        },
        {
          id: 7,
          title: 'Lymphatic Drainage Massage',
          description: 'Lymphatic drainage massage can promote the flow of lymphatic fluid and blood circulation, eliminate edema, fatigue, improve symptoms such as lower back pain. It helps the body effectively remove toxic substances, enhance the body\'s physiological functions, and improve the body\'s immune function. It has a good preventive effect on chronic diseases.'
        }
      ],
      footer:{
        copyright: '©2023 Canadian Han TCM'
      },
      doctorProfile: doctorInfo.english,
      priceInfo: priceInfo.english,
      contactUs: {
        title: 'Contact Us',
        content: [
          'Address: 15240 Thrift Ave #105',
          'White Rock, BC V4B 2L1',
          'Email: canadianhantcmclinic@gmail.com',
          'Call Us: 604-928-1898'
        ]
      }
    }
}

export const chinese = {
    translation: {
      header: {
        name: '汉中医',
        option1: '关于我们',
        option2: '诊疗项目',
        option3: '联系方式',
        bookOnline: '在线预约',
        languageSwitch: 'English',
        brandName: '汉中医'
      },
      floatingContact:{
        bookOnline: '在线预约',
        wechatLabel: '预约请加微信',
        callLabel: '电话预约: ',
        phone: '604-928-1898'
      },
      booking:{
        title: '在线预约',
        hoursTitle: '诊所工作时间：',
        hours1: '周一至周六：10:00am – 8:00pm',
        hours2: '周日：10:00am – 6:00pm'
      },
      clinicInfo:[
        {
          id: 0,
          title: '我们的理念',
          description: '汉中医诊所(Canadian Han TCM Clinic)，是主要提供中医药门诊和治疗的中医诊所。在中医药理论的指导下辨证施治，运用中药（传统中草药和中药颗粒剂）、针灸、推拿按摩、拨罐、刮痧等传统中医疗法开展诊疗服务。根据您的身体状况及需求为您提供综合性的中医治疗方案。',
        },
        {
          id: 1,
          title: '推拿',
          description: '是指医者根据中医经络、腧穴理论，运用自己的双手、肘臂作用于患者体表之疼痛部位、疲劳损伤部位及不适之所在，运用推、拿、按、摩、揉、捏、点、拍等形式多样的手法，以达到疏通经络、推行气血、疗伤止痛、祛邪扶正、调和阴阳的疗效。',
        },
        {
          id: 2,
          title: '针灸',
          description: '针灸是源于中国一种的治疗疾病的手段，是指在中医理论的指导下，利用针刺与艾灸进行治疗。“针”即针刺，以针刺入人体穴位治病，根据 “虚则补之，实则泻之”的辨证原则，进针后通过补、泻、平补平泻等手法的配合运用，以取得人体本身的调节反应。“灸”即艾灸，以火点燃艾炷或艾条，温热穴位，将热力透入肌肤，以温通气血，通络止痛。针刺或艾灸就是以这种方式刺激体表穴位，并通过全身经络的传导，来调整气血和脏腑的功能，从而达到“扶正祛邪”、“治病保健”的目的',
        },
        {
          id: 3,
          title: '中药',
          description: '以中医药理论为指导，对天然药物进行采集、炮制、制剂，说明其作用机理，指导临床应用，这个药物统称为中药。中药治疗就是指在中医理论指导下，用于预防、诊断、治疗疾病并具有康复与保健作用的物质。中药主要来源于天然药及其加工品，包括植物药、动物药、矿物药及部分化学、生物制品类药物。中药以天然植物药居多，故中药常称为“本草”。',
        },
        {
          id: 4,
          title: '拔罐',
          description: '是一种以罐为工具，利用燃火、抽气等方法产生负压，使之吸附于体表，造成局部瘀血，以达到通经活络、行气活血、消肿止痛、祛风散寒等作用的中医疗法。拔罐疗法在古代中国有着悠久的历史，早在成书于西汉时期（公元前202年）的帛书《五十二病方》中就有关于“角法”（相当于火罐疗法）的记载。',
        },
        {
          id: 5,
          title: '刮痧',
          description: '刮痧是以中医经络腧穴理论为指导，通过特制的刮痧器具和相应的手法，蘸取一定的介质，在体表进行反复刮动、摩擦，使皮肤局部出现红色粟粒状，或暗红色出血点等“出痧”变化，从而达到活血通络止痛舒筋的作用。可配合针灸、拔罐、刺络放血等疗法使用，加强活血化瘀、通经止痛、驱邪排毒的功效。',
        },
        {
          id: 6,
          title: '头疗',
          description: '按照头颈部经络分布，堆头颈部进行力度适中的按、点、摩、梳。头疗是一种非常舒服的养生方式，可较迅速地舒缓减轻头晕、头痛、颈项强直酸痛等问题时；头疗还可以帮助睡眠、缓解疲劳、并且调理白发及脱发。',
        },
        {
          id: 7,
          title: '淋巴排毒按摩',
          description: '淋巴排毒按摩可以促进淋巴液的流动及血液循环，可以消除浮肿，疲劳，改善腰酸背痛等的症状。帮助身体有效的排出有毒物质，增强身体的生理功能，提高身体免疫功能，对于慢性疾病具有很好的预防作用。'
        }
      ],
      footer:{
        copyright: '©2023 汉中医'
      },
      doctorProfile: doctorInfo.chinese,
      priceInfo: priceInfo.chinese,
      contactUs:{
        title: '联系方式',
        content: [
          '地址：15240 Thrift Ave #105',
          'White Rock, BC V4B 2L1',
          '电子邮箱：canadianhantcmclinic@gmail.com',
          '电话：604-928-1898',
          '微信号：请扫描二维码添加'
        ]
      }
    }
}

